var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinimizeSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,8c0,0.5517578-0.4482422,1-1,1H2v2h6c1.6542969,0,3-1.3457031,3-3V2H9V8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,21H2v2h6c0.5517578,0,1,0.4482422,1,1v6h2v-6C11,22.3457031,9.6542969,21,8,21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,24v6h2v-6c0-0.5517578,0.4482422-1,1-1h6v-2h-6C22.3457031,21,21,22.3457031,21,24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,8V2h-2v6c0,1.6542969,1.3457031,3,3,3h6V9h-6C23.4482422,9,23,8.5517578,23,8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeSmall);
export default __webpack_public_path__ + "static/media/minimize--small.f9b46b9468c55300d9de2d9fe07ab9a6.svg";
export { ForwardRef as ReactComponent };